import { Input } from '~/components/common/CurieInput'
import { ConnectionType, TypeConnection } from '~/constants/connections'
import { ConnectViaOauthIcon } from '~/constants/icon'
import MultiLocationComponent from './MultiLocationComponent'

interface ConnectPopoverContentProps {
  conn: TypeConnection
  isUpdatingToken: Record<string, boolean>
  onConnect?: () => void
  onDeleteConnection?: (connId: string) => void
  isConnected?: boolean
}

export function ConnectPopoverContent({
  conn,
  isUpdatingToken,
  onConnect,
  onDeleteConnection,
  isConnected
}: ConnectPopoverContentProps) {
  if (conn.id === ConnectionType.LocalSync) {
    return <MultiLocationComponent />
  }

  return (
    <div className='w-full'>
      <div className=''>
        <button
          className={`${isConnected ? 'w-full px-2' : 'w-full px-3'} h-8 rounded-lg font-['Geist'] hover:bg-[rgba(0,0,0,0.04)]`}
          onClick={onConnect}
          disabled={isUpdatingToken[conn.id]}
        >
          <div className='flex flex-row justify-between items-center w-full'>
            <div className='text-[rgba(0,0,0,0.88)] text-base leading-[22px] text-ellipsis select-none'>
              {isConnected ? 'Modify Connection' : 'Connect via Oauth'}
            </div>
            <div className='w-4 h-4 flex items-center justify-center'>
              <ConnectViaOauthIcon />
            </div>
          </div>
        </button>
      </div>

      {isConnected && onDeleteConnection && (
        <>
          <div className='w-full border-t border-[rgba(0,0,0,0.06)] my-2'></div>
          <div className=''>
            <button
              className="w-full px-2 h-8 rounded-lg font-['Geist'] hover:bg-[rgba(0,0,0,0.04)]"
              onClick={() => onDeleteConnection(conn.id)}
            >
              <div className='flex flex-row justify-between items-center w-full'>
                <div className='text-[#C22C15] text-base leading-[22px] text-ellipsis select-none'>
                  Remove Connection
                </div>
              </div>
            </button>
          </div>
        </>
      )}
    </div>
  )
}

interface CustomInputProps {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  placeholder: string
  className?: string
}

export function CustomInput({
  value,
  onChange,
  disabled,
  placeholder,
  className = ''
}: CustomInputProps) {
  return (
    <Input
      className={`w-[364px] h-8 px-[11px] bg-white rounded-md border border-[#d9d9d9] hover:border-[#4096ff] text-sm font-['Geist'] leading-snug block ${className}`}
      placeholder={placeholder}
      autoFocus
      value={value}
      disabled={disabled}
      onChange={e => onChange(e.target.value)}
    />
  )
}
